import Box from "@mui/material/Box";
import styled from "styled-components";

export const Container = styled(Box)`
    height: 8rem;
    width: 8rem;
    display: flex;
    justify-content: center;
    align-items: center;
` as typeof Box;